import * as gl_matrix from 'gl-matrix'

var copyVideo = false

function initShaderProgram(gl, vsSource, fsSource) {
    function loadShader(gl, type, source) {
        const shader = gl.createShader(type)

        gl.shaderSource(shader, source)

        gl.compileShader(shader)

        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            console.error(
                'An error occurred compiling the shaders: ' +
                    gl.getShaderInfoLog(shader)
            )
            debugger
            gl.deleteShader(shader)
            return null
        }

        return shader
    }

    const vertexShader = loadShader(gl, gl.VERTEX_SHADER, vsSource)
    const fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, fsSource)

    const shaderProgram = gl.createProgram()
    gl.attachShader(shaderProgram, vertexShader)
    gl.attachShader(shaderProgram, fragmentShader)
    gl.linkProgram(shaderProgram)

    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
        alert(
            'Unable to initialize the shader program: ' +
                gl.getProgramInfoLog(shaderProgram)
        )
        return null
    }

    return shaderProgram
}

function initBuffers(gl) {
    const positionBuffer = gl.createBuffer()

    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer)

    const positions = [-1.0, 1.0, -1.0, -1.0, 1.0, 1.0, 1.0, -1.0]

    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW)

    const textureCoordBuffer = gl.createBuffer()
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer)

    const textureCoordinates = [
        // Front
        0.0,
        0.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        1.0,
    ]

    gl.bufferData(
        gl.ARRAY_BUFFER,
        new Float32Array(textureCoordinates),
        gl.STATIC_DRAW
    )

    return {
        position: positionBuffer,
        textureCoord: textureCoordBuffer,
    }
}

function initTexture(
    gl,
    width = 1,
    height = 1,
    internalFormat = undefined,
    interpolation = gl.LINEAR
) {
    const texture = gl.createTexture()
    gl.bindTexture(gl.TEXTURE_2D, texture)

    const level = 0
    internalFormat = internalFormat === undefined ? gl.RGBA : internalFormat
    const border = 0
    const srcFormat = gl.RGBA
    const srcType = gl.UNSIGNED_BYTE
    const pixel = new Uint8Array([0, 0, 255, 255])
    gl.texImage2D(
        gl.TEXTURE_2D,
        level,
        internalFormat,
        width,
        height,
        border,
        srcFormat,
        srcType,
        null
    )
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, interpolation)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, interpolation)

    return texture
}

function updateTexture(gl, texture, image) {
    const level = 0
    const internalFormat = gl.RGBA
    const srcFormat = gl.RGBA
    const srcType = gl.UNSIGNED_BYTE
    gl.bindTexture(gl.TEXTURE_2D, texture)
    gl.texImage2D(
        gl.TEXTURE_2D,
        level,
        internalFormat,
        srcFormat,
        srcType,
        image
    )
}

function initFBO(gl, texture) {
    // Create a framebuffer
    var fbo = gl.createFramebuffer()
    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo)

    // Attach a texture to it.
    gl.framebufferTexture2D(
        gl.FRAMEBUFFER,
        gl.COLOR_ATTACHMENT0,
        gl.TEXTURE_2D,
        texture,
        0
    )
    return fbo
}

class ImageFilteShader {
    constructor(
        gl,
        src_canvas,
        render_size,
        delay_init = false,
        flip_y = true
    ) {
        this.gl = gl
        this.src_canvas = src_canvas
        this.render_size = render_size
        this.flip_y_scale = flip_y ? -1.0 : 1.0
        this.flip_y_offset = flip_y ? 1.0 : 0.0

        if (!delay_init) this.setup(gl)
    }

    setup(gl) {
        this.buffers = initBuffers(gl)

        this.create_input_tex()
        this.create_output_tex()
        this.load_shader_code()
        this.shader_program = initShaderProgram(gl, this.shaderV, this.shaderF)
        this.shader_info = this.build_shader_info()
    }

    create_input_tex() {
        this.input_tex = null
    }

    create_output_tex() {
        this.output_tex = initTexture(
            this.gl,
            this.render_size.width,
            this.render_size.height
        )
    }

    swap_output_tex(new_tex) {
        const old = this.output_tex
        this.output_tex = new_tex
        return old
    }

    build_shader_info() {
        const gl = this.gl
        return {
            program: this.shader_program,
            attribLocations: {
                vertexPosition: gl.getAttribLocation(
                    this.shader_program,
                    'aVertexPosition'
                ),
                textureCoord: gl.getAttribLocation(
                    this.shader_program,
                    'aTextureCoord'
                ),
            },
            uniformLocations: {
                uSampler: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler'
                ),
                u_textureSize: gl.getUniformLocation(
                    this.shader_program,
                    'u_textureSize'
                ),
            },
        }
    }

    load_shader_code() {
        this.shaderV = '@'
        this.shaderF = '@'
        throw Error('Overwrite this method to create shader code!')
    }

    apply_shader(
        gl,
        programInfo,
        buffers,
        texture_a,
        scaledWidth,
        scaledHeight,
        uniform_param
    ) {
        gl.viewport(0, 0, scaledWidth, scaledHeight)

        {
            const numComponents = 2
            const type = gl.FLOAT
            const normalize = false
            const stride = 0
            const offset = 0
            gl.bindBuffer(gl.ARRAY_BUFFER, buffers.position)
            gl.vertexAttribPointer(
                programInfo.attribLocations.vertexPosition,
                numComponents,
                type,
                normalize,
                stride,
                offset
            )
            gl.enableVertexAttribArray(
                programInfo.attribLocations.vertexPosition
            )
        }

        {
            const numComponents = 2
            const type = gl.FLOAT
            const normalize = false
            const stride = 0
            const offset = 0
            gl.bindBuffer(gl.ARRAY_BUFFER, buffers.textureCoord)
            gl.vertexAttribPointer(
                programInfo.attribLocations.textureCoord,
                numComponents,
                type,
                normalize,
                stride,
                offset
            )
            gl.enableVertexAttribArray(programInfo.attribLocations.textureCoord)
        }

        gl.useProgram(programInfo.program)
        gl.uniform1i(programInfo.uniformLocations.uSampler, 0)

        for (let [gl_func, args] of Object.entries(uniform_param)) {
            switch (gl_func) {
                case 'uniform1f':
                    gl.uniform1f(...args)
                    break
                case 'uniform2f':
                    gl.uniform2f(...args)
                    break
                case 'uniform3f':
                    gl.uniform3f(...args)
                    break
                case 'uniform4f':
                    gl.uniform4f(...args)
                    break
                case 'uniform1i':
                    gl.uniform1i(...args)
                    break
                case 'uniform2i':
                    gl.uniform2i(...args)
                    break
                default:
                    throw Error(`${gl_func}???`)
            }
        }

        gl.activeTexture(gl.TEXTURE0)
        gl.bindTexture(gl.TEXTURE_2D, texture_a)

        {
            const vertexCount = 4
            const offset = 0
            gl.drawArrays(gl.TRIANGLE_STRIP, offset, vertexCount)
        }
    }

    apply(input_tex, framebuffer) {
        const gl = this.gl

        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer)
        gl.framebufferTexture2D(
            gl.FRAMEBUFFER,
            gl.COLOR_ATTACHMENT0,
            gl.TEXTURE_2D,
            this.output_tex,
            0
        )

        const uniform_parm = {}
        uniform_parm.uniform2f = [
            this.shader_info.uniformLocations.u_textureSize,
            this.render_size.width,
            this.render_size.height,
        ]

        this.apply_shader(
            gl,
            this.shader_info,
            this.buffers,
            this.input_tex !== null ? this.input_tex : input_tex,
            this.render_size.width,
            this.render_size.height,
            uniform_parm
        )
        return this.output_tex
    }
}

class ImageStackShader extends ImageFilteShader {
    build_shader_info() {
        const gl = this.gl
        return {
            program: this.shader_program,
            attribLocations: {
                vertexPosition: gl.getAttribLocation(
                    this.shader_program,
                    'aVertexPosition'
                ),
                textureCoord: gl.getAttribLocation(
                    this.shader_program,
                    'aTextureCoord'
                ),
            },
            uniformLocations: {
                uSampler1: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler1'
                ),
                uSampler2: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler2'
                ),
                u_textureSize: gl.getUniformLocation(
                    this.shader_program,
                    'u_textureSize'
                ),
            },
        }
    }

    apply_shader(
        gl,
        programInfo,
        buffers,
        input_tex_list,
        scaledWidth,
        scaledHeight,
        uniform_param
    ) {
        gl.viewport(0, 0, scaledWidth, scaledHeight)

        {
            const numComponents = 2
            const type = gl.FLOAT
            const normalize = false
            const stride = 0
            const offset = 0
            gl.bindBuffer(gl.ARRAY_BUFFER, buffers.position)
            gl.vertexAttribPointer(
                programInfo.attribLocations.vertexPosition,
                numComponents,
                type,
                normalize,
                stride,
                offset
            )
            gl.enableVertexAttribArray(
                programInfo.attribLocations.vertexPosition
            )
        }

        {
            const numComponents = 2
            const type = gl.FLOAT
            const normalize = false
            const stride = 0
            const offset = 0
            gl.bindBuffer(gl.ARRAY_BUFFER, buffers.textureCoord)
            gl.vertexAttribPointer(
                programInfo.attribLocations.textureCoord,
                numComponents,
                type,
                normalize,
                stride,
                offset
            )
            gl.enableVertexAttribArray(programInfo.attribLocations.textureCoord)
        }

        gl.useProgram(programInfo.program)
        gl.uniform1i(programInfo.uniformLocations.uSampler1, 0)
        gl.uniform1i(programInfo.uniformLocations.uSampler2, 1)
        if (input_tex_list.length > 2)
            gl.uniform1i(programInfo.uniformLocations.uSampler3, 2)

        for (let [gl_func, args] of Object.entries(uniform_param)) {
            switch (gl_func) {
                case 'uniform1f':
                    gl.uniform1f(...args)
                    break
                case 'uniform2f':
                    gl.uniform2f(...args)
                    break
                case 'uniform3f':
                    gl.uniform3f(...args)
                    break
                case 'uniform4f':
                    gl.uniform4f(...args)
                    break
                case 'uniform1i':
                    gl.uniform1i(...args)
                    break
                case 'uniform2i':
                    gl.uniform2i(...args)
                    break
                default:
                    throw Error(`${gl_func}???`)
            }
        }

        const TEX_ID = [gl.TEXTURE0, gl.TEXTURE1, gl.TEXTURE2]
        for (let i = 0; i < input_tex_list.length; i++) {
            const tex = input_tex_list[i]
            gl.activeTexture(TEX_ID[i])
            gl.bindTexture(gl.TEXTURE_2D, tex)
        }

        {
            const vertexCount = 4
            const offset = 0
            gl.drawArrays(gl.TRIANGLE_STRIP, offset, vertexCount)
        }
    }

    apply(input_tex, framebuffer) {
        if (input_tex.constructor.name !== 'Array')
            throw Error('This shader expect multiple input textures!')
        return super.apply(input_tex, framebuffer)
    }
}

class MotionShader extends ImageStackShader {
    constructor(gl, src_canvas, render_size, decay_rate, flip_y) {
        super(gl, src_canvas, render_size, true, flip_y)
        if (decay_rate <= 0 || decay_rate >= 1)
            throw Error(
                'Invalid decay rate value, it should be in the range of (0, 1)'
            )
        this.decay_rate = decay_rate
        this.setup(gl)
    }

    build_shader_info() {
        const gl = this.gl
        return {
            program: this.shader_program,
            attribLocations: {
                vertexPosition: gl.getAttribLocation(
                    this.shader_program,
                    'aVertexPosition'
                ),
                textureCoord: gl.getAttribLocation(
                    this.shader_program,
                    'aTextureCoord'
                ),
            },
            uniformLocations: {
                uSampler1: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler1'
                ),
                uSampler2: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler2'
                ),
                uSampler3: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler3'
                ),
                u_textureSize: gl.getUniformLocation(
                    this.shader_program,
                    'u_textureSize'
                ),
            },
        }
    }

    load_shader_code() {
        this.shaderV = `
            attribute vec4 aVertexPosition;
            attribute vec2 aTextureCoord;

            varying highp vec2 vTextureCoord;
            varying highp vec3 vLighting;

            void main(void) {
                gl_Position = aVertexPosition;
                vTextureCoord = aTextureCoord * 2.0;
            }
        `
        this.shaderF = `
            precision highp float;
            uniform sampler2D uSampler1; // preious frame
            uniform sampler2D uSampler2; // current frame
            uniform sampler2D uSampler3; //longterm motion
            uniform float sColorThreshold;
            varying highp vec2 vTextureCoord;

            void main() {
                highp vec3 tex1, tex2;
                float delta, color_distance, tex3;

                tex1 = texture2D(uSampler1, vTextureCoord * vec2(1, ${this.flip_y_scale}) + vec2(0, ${this.flip_y_offset})).rgb;
                tex2 = texture2D(uSampler2, vTextureCoord * vec2(1, ${this.flip_y_scale}) + vec2(0, ${this.flip_y_offset})).rgb;
                tex3 = texture2D(uSampler3, vTextureCoord * vec2(.5, .5) * vec2(1, -1) + vec2(0, 1)).r;

                color_distance = (distance(tex1, tex2) + tex3 * ${this.decay_rate});
                // delta = smoothstep(color_distance - 0.25, color_distance + 0.25, sColorThreshold);
                
                gl_FragColor = vec4(vec3(color_distance), 1.0);
            }
        `
    }
}

class MaskingShader extends ImageStackShader {
    build_shader_info() {
        const gl = this.gl
        return {
            program: this.shader_program,
            attribLocations: {
                vertexPosition: gl.getAttribLocation(
                    this.shader_program,
                    'aVertexPosition'
                ),
                textureCoord: gl.getAttribLocation(
                    this.shader_program,
                    'aTextureCoord'
                ),
            },
            uniformLocations: {
                uSampler1: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler1'
                ),
                uSampler2: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler2'
                ),
                u_textureSize: gl.getUniformLocation(
                    this.shader_program,
                    'u_textureSize'
                ),
            },
        }
    }

    load_shader_code() {
        this.shaderV = `
            attribute vec4 aVertexPosition;
            attribute vec2 aTextureCoord;

            varying highp vec2 vTextureCoord;
            varying highp vec3 vLighting;

            void main(void) {
                gl_Position = aVertexPosition;
                vTextureCoord = (aTextureCoord * vec2(1.0, -1.0)) + vec2(0, 1.0);
            }
        `
        this.shaderF = `
            precision highp float;
            uniform sampler2D uSampler1; // image
            uniform sampler2D uSampler2; // mask
            varying highp vec2 vTextureCoord;

            void main() {
                highp vec3 pixel, mask;
                float delta, color_distance, tex3;

                pixel = texture2D(uSampler1, vTextureCoord).rgb;
                mask = texture2D(uSampler2, vTextureCoord).rgb;
                
                gl_FragColor = vec4(vec3(pixel * mask), 1.0);
            }
        `
    }
}

class GradMaskShader extends ImageFilteShader {
    load_shader_code() {
        this.shaderV = `
            attribute vec4 aVertexPosition;
            attribute vec2 aTextureCoord;
    
            varying highp vec2 vTextureCoord;
            varying highp vec3 vLighting;
    
            void main(void) {
                gl_Position = aVertexPosition;
                // vTextureCoord = aTextureCoord;
                vTextureCoord = (aTextureCoord * 2.0 * vec2(1.0, ${this.flip_y_scale})) + vec2(0, ${this.flip_y_offset});
            }
        `

        this.shaderF = `
            precision highp float;
            varying highp vec2 vTextureCoord;
            uniform vec2 u_textureSize;
            uniform sampler2D uSampler;
            uniform int u_threshold;

            void main(void) {
                vec2 onePixel = vec2(1.0, 1.0) / u_textureSize;
                vec3 v_00 = texture2D(uSampler, vTextureCoord).rgb;
                float fp_threshold = float(u_threshold) / 255.0;
                if (v_00.r > fp_threshold) {
                    // gl_FragColor = vec4(vec3(v_00.r), 1.0);
                    gl_FragColor = vec4(1.0);
                }
                else {
                    gl_FragColor = vec4(vec3(0.0), 1.0);
                }
            }
        `
    }

    build_shader_info() {
        const gl = this.gl
        return {
            program: this.shader_program,
            attribLocations: {
                vertexPosition: gl.getAttribLocation(
                    this.shader_program,
                    'aVertexPosition'
                ),
                textureCoord: gl.getAttribLocation(
                    this.shader_program,
                    'aTextureCoord'
                ),
            },
            uniformLocations: {
                uSampler: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler'
                ),
                u_textureSize: gl.getUniformLocation(
                    this.shader_program,
                    'u_textureSize'
                ),
                u_threshold: gl.getUniformLocation(
                    this.shader_program,
                    'u_threshold'
                ),
            },
        }
    }

    apply(input_tex, framebuffer, uint8_img_grad_thres) {
        const gl = this.gl

        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer)
        gl.framebufferTexture2D(
            gl.FRAMEBUFFER,
            gl.COLOR_ATTACHMENT0,
            gl.TEXTURE_2D,
            this.output_tex,
            0
        )

        const uniform_parm = {}
        uniform_parm.uniform2f = [
            this.shader_info.uniformLocations.u_textureSize,
            this.render_size.width,
            this.render_size.height,
        ]
        uniform_parm.uniform1i = [
            this.shader_info.uniformLocations.u_threshold,
            uint8_img_grad_thres,
        ]

        this.apply_shader(
            gl,
            this.shader_info,
            this.buffers,
            this.input_tex !== null ? this.input_tex : input_tex,
            this.render_size.width,
            this.render_size.height,
            uniform_parm
        )
        return this.output_tex
    }
}

class ReduceMax2DShader extends ImageFilteShader {
    load_shader_code() {
        this.shaderV = `
            attribute vec4 aVertexPosition;
            attribute vec2 aTextureCoord;
    
            varying highp vec2 vTextureCoord;
            varying highp vec3 vLighting;
    
            void main(void) {
                gl_Position = aVertexPosition;
                vTextureCoord = aTextureCoord;
            }
        `

        this.shaderF = `
            precision highp float;
            
            uniform sampler2D uSampler;
            uniform vec2 u_textureSize;
            varying highp vec2 vTextureCoord;
            
            void main() {
                vec2 onePixel = vec2(1.0, 1.0) / u_textureSize;
                highp vec3 tex1;
                
                vec2 flip_coord = vTextureCoord * vec2(1, -1) + vec2(0, 1.0);
                float row_sum = 0.0;
                float colume_sum = 0.0;
 
    
                if (flip_coord.x < onePixel.x) {  // x=0, y=[0: h-1]
                    for (int i = 0; i < ${this.render_size.width}; i += 1) {
                        float j = float(i);
                        vec2 point = vec2(j / u_textureSize.x, flip_coord.y);
                        // colume_sum += texture2D(uSampler, point).r;
                        colume_sum = max(texture2D(uSampler, point).r, colume_sum);
                    }
                    // gl_FragColor = vec4(colume_sum / float(${this.render_size.width}), 0, 0, 1);
                    gl_FragColor = vec4(colume_sum, 0, 0, 1);
                }
                else if (vTextureCoord.y <= onePixel.y  && vTextureCoord.x > onePixel.x) { // x=[0: w-1], y=0
                    for (int i = 0; i < ${this.render_size.height}; i += 1) {
                        vec2 point = vec2(vTextureCoord.x, float(i) / u_textureSize.y + 0.5);
                        // row_sum += texture2D(uSampler, point).r;
                        row_sum = max(texture2D(uSampler, point).r, row_sum);
                    }
                    // gl_FragColor = vec4(0, row_sum / float(${this.render_size.height}), 0, 1.0);
                    gl_FragColor = vec4(0, row_sum, 0, 1.0);
                }
                else if (onePixel.y * 2.0 > vTextureCoord.y 
                        && vTextureCoord.y >= onePixel.y
                        && onePixel.x * 2.0 > vTextureCoord.x
                        && vTextureCoord.x >= onePixel.x) {
                    for (int i = 0; i < ${this.render_size.height}; i += 1) {
                        vec2 point = vec2(vTextureCoord.x, float(i) / u_textureSize.y);
                        row_sum += texture2D(uSampler, point).r;
                    }
                    gl_FragColor = vec4(0, row_sum / float(${this.render_size.height}), 0, 1.0);
                }
                else {
                    gl_FragColor = vec4(vec3(vTextureCoord.x, vTextureCoord.y, 0.0), 1.0);
                    // gl_FragColor = vec4(vec3(0), 1.0);
                }
            }
        `
    }
}

class AvgPoolingShader extends ImageFilteShader {
    load_shader_code() {
        this.shaderV = `
            attribute vec4 aVertexPosition;
            attribute vec2 aTextureCoord;

            varying highp vec2 vTextureCoord;
            varying highp vec3 vLighting;

            void main(void) {
                gl_Position = aVertexPosition;
                vTextureCoord = aTextureCoord * 2.0;
            }
        `

        this.shaderF = `
            precision highp float;
        
            uniform sampler2D sTexture1;
            uniform vec2 u_textureSize;
            varying highp vec2 vTextureCoord;
            
            void main() {
                vec2 onePixel = vec2(1.0, 1.0) / u_textureSize;
                highp vec3 tex1;
                vec2 flip_coord = vTextureCoord * vec2(1, ${this.flip_y_scale}) + vec2(0, ${this.flip_y_offset});

                float v_00 = texture2D(sTexture1, flip_coord + onePixel * vec2(-1, -1)).r;
                float v_01 = texture2D(sTexture1, flip_coord + onePixel * vec2(0, -1)).r;
                float v_02 = texture2D(sTexture1, flip_coord + onePixel * vec2(1, -1)).r;
                float v_10 = texture2D(sTexture1, flip_coord + onePixel * vec2(-1, 0)).r;
                float v_20 = texture2D(sTexture1, flip_coord + onePixel * vec2(-1, 1)).r;
                float v_11 = texture2D(sTexture1, flip_coord + onePixel * vec2(0, 0)).r;
                float v_12 = texture2D(sTexture1, flip_coord + onePixel * vec2(1, 0)).r;
                float v_21 = texture2D(sTexture1, flip_coord + onePixel * vec2(0, 1)).r;
                float v_22 = texture2D(sTexture1, flip_coord + onePixel * vec2(1, 1)).r;
                float pixel_sum = v_00 + v_01 + v_02 + v_10 + v_20 + v_11 + v_12 + v_21 + v_22;
                gl_FragColor = vec4(vec3(pixel_sum / 9.0), 1.0);
            }
        `
    }
}

class RectShader extends ImageFilteShader {
    build_shader_info() {
        const gl = this.gl
        return {
            program: this.shader_program,
            attribLocations: {
                vertexPosition: gl.getAttribLocation(
                    this.shader_program,
                    'aVertexPosition'
                ),
                textureCoord: gl.getAttribLocation(
                    this.shader_program,
                    'aTextureCoord'
                ),
            },
            uniformLocations: {
                uSampler: gl.getUniformLocation(
                    this.shader_program,
                    'uSampler'
                ),
                u_textureSize: gl.getUniformLocation(
                    this.shader_program,
                    'u_textureSize'
                ),
                u_boxCrood: gl.getUniformLocation(
                    this.shader_program,
                    'u_boxCrood'
                ),
                u_fpColor: gl.getUniformLocation(
                    this.shader_program,
                    'u_fpColor'
                ),
            },
        }
    }

    load_shader_code() {
        this.shaderV = `
            attribute vec4 aVertexPosition;
            attribute vec2 aTextureCoord;
    
            varying highp vec2 vTextureCoord;
            varying highp vec3 vLighting;
    
            void main(void) {
                gl_Position = aVertexPosition;
                vTextureCoord = aTextureCoord * vec2(1., -1.) + vec2(0.0, 1.0);
                // vTextureCoord = aTextureCoord;
            }
        `

        this.shaderF = `
            precision highp float;

            uniform sampler2D sTexture1;
            uniform float u_fpColor;
            uniform vec2 u_textureSize;
            uniform vec4 u_boxCrood; // [xmin, xmax, ymin, ymax]
            varying highp vec2 vTextureCoord;
            
            void main() {
                // vec4 fpBoxCrood = u_boxCrood / vec4(u_textureSize.x, u_textureSize.x, u_textureSize.y, u_textureSize.y);
                vec4 fpBoxCrood = u_boxCrood;
                fpBoxCrood =  fpBoxCrood * vec4(1., 1., -1., -1.) + vec4(0., 0., 1., 1.);
                
                // swap ymin ymax too
                if (
                    vTextureCoord.x >= fpBoxCrood.r && vTextureCoord.x < fpBoxCrood.g &&
                    vTextureCoord.y >= fpBoxCrood.a && vTextureCoord.y < fpBoxCrood.b
                ) { 
                    gl_FragColor = vec4(u_fpColor);
                }
                else {
                    gl_FragColor = texture2D(sTexture1, vTextureCoord);
                }
            }
        `
    }

    apply(input_tex, framebuffer, rect_box, color_fp = 1) {
        const gl = this.gl

        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer)
        gl.framebufferTexture2D(
            gl.FRAMEBUFFER,
            gl.COLOR_ATTACHMENT0,
            gl.TEXTURE_2D,
            this.output_tex,
            0
        )

        const uniform_parm = {}
        uniform_parm.uniform2f = [
            this.shader_info.uniformLocations.u_textureSize,
            this.render_size.width,
            this.render_size.height,
        ]
        uniform_parm.uniform4f = [
            this.shader_info.uniformLocations.u_boxCrood,
            rect_box[0],
            rect_box[1],
            rect_box[2],
            rect_box[3],
        ]
        uniform_parm.uniform1f = [
            this.shader_info.uniformLocations.u_fpColor,
            color_fp,
        ]

        this.apply_shader(
            gl,
            this.shader_info,
            this.buffers,
            this.input_tex !== null ? this.input_tex : input_tex,
            this.render_size.width,
            this.render_size.height,
            uniform_parm
        )
        return this.output_tex
    }
}

class ImageGradShader extends ImageFilteShader {
    load_shader_code() {
        this.shaderV = `
            attribute vec4 aVertexPosition;
            attribute vec2 aTextureCoord;
    
            varying highp vec2 vTextureCoord;
            varying highp vec3 vLighting;
    
            void main(void) {
                gl_Position = aVertexPosition;
                // vTextureCoord = aTextureCoord;
                vTextureCoord = (aTextureCoord * vec2(1.0, ${this.flip_y_scale})) + vec2(0, ${this.flip_y_offset});
            }
        `

        this.shaderF = `
            precision highp float;
            varying highp vec2 vTextureCoord;
            uniform vec2 u_textureSize;
            uniform sampler2D uSampler;

            void main(void) {
                vec2 onePixel = vec2(1.0, 1.0) / u_textureSize;

                vec3 v_00 = texture2D(uSampler, vTextureCoord + onePixel * vec2(-1, -1)).rgb;
                vec3 v_01 = texture2D(uSampler, vTextureCoord + onePixel * vec2(0, -1)).rgb;
                vec3 v_02 = texture2D(uSampler, vTextureCoord + onePixel * vec2(1, -1)).rgb;
                vec3 v_10 = texture2D(uSampler, vTextureCoord + onePixel * vec2(-1, 0)).rgb;
                vec3 v_20 = texture2D(uSampler, vTextureCoord + onePixel * vec2(-1, 1)).rgb;
                vec3 v_11 = texture2D(uSampler, vTextureCoord + onePixel * vec2(0, 0)).rgb;
                vec3 v_12 = texture2D(uSampler, vTextureCoord + onePixel * vec2(1, 0)).rgb;
                vec3 v_21 = texture2D(uSampler, vTextureCoord + onePixel * vec2(0, 1)).rgb;
                vec3 v_22 = texture2D(uSampler, vTextureCoord + onePixel * vec2(1, 1)).rgb;
                // float pixel_sum = v_00 + v_01 + v_02 + v_10 + v_20 + v_11 + v_12 + v_21 + v_22;
                vec3 sobel_x = -1.0 * v_00 + 1.0 * v_02 + -2.0 * v_10 + -1.0 * v_20 + 2.0 * v_12  + 1.0 * v_22;
                vec3 sobel_y = -1.0 * v_00 + -2.0 * v_01 + -1.0 * v_02 + 1.0 * v_20 + 2.0 * v_21 + 1.0 * v_22;
                float sobel_gray_x = (sobel_x.r + sobel_x.g + sobel_x.b) / 3.0 / 8.0;
                float sobel_gray_y = (sobel_y.r + sobel_y.g + sobel_y.b) / 3.0 / 8.0;
                float norm = sqrt(pow(sobel_gray_x, 2.0) + pow(sobel_gray_y, 2.0));

                // gl_FragColor = vec4(vec3(norm / 1.414), 1.0);  // img grad can be -8~8, norm will be 0 ~ 8 * 2**0.5
                gl_FragColor = vec4(vec3(norm), 1.0);  // img grad can be -8~8, norm will be 0 ~ 8 * 2**0.5
            }
        `
    }
}

class DilateFilterShader extends ImageFilteShader {
    load_shader_code() {
        this.shaderV = `
            attribute vec4 aVertexPosition;
            attribute vec2 aTextureCoord;
    
            varying highp vec2 vTextureCoord;
            varying highp vec3 vLighting;
    
            void main(void) {
                gl_Position = aVertexPosition;
                vTextureCoord = (aTextureCoord * vec2(1.0, -1.0)) + vec2(0, 1.0);
            }
        `

        this.shaderF = `
            precision highp float;
            varying highp vec2 vTextureCoord;
            uniform vec2 u_textureSize;
            uniform sampler2D uSampler;

            void main(void) {
                vec2 onePixel = vec2(1.0, 1.0) / u_textureSize;
                
                float local_max = 0.0;
                const int N = 3;

                for(int y = 0; y < N; y++) {
                    for(int x = 0; x < N; x++) {
                        float pixel = texture2D(uSampler, vTextureCoord + onePixel * vec2(float(x), float(y))).r;
                        local_max = max(local_max, pixel);
                    }
                }

                gl_FragColor = vec4(vec3(local_max), 1.0);
                // gl_FragColor = vec4(vec3((vTextureCoord.y) * (1.0 - vTextureCoord.x)), 1.0);
            }
        `
    }
}

class ReduceAllShader extends ImageFilteShader {
    constructor(gl, src_canvas, render_size, reduce_type) {
        super(gl, src_canvas, render_size, true)
        this.type = reduce_type
        this.setup(gl)
    }

    load_shader_code() {
        this.shaderV = `
            attribute vec4 aVertexPosition;
            attribute vec2 aTextureCoord;
    
            varying highp vec2 vTextureCoord;
            varying highp vec3 vLighting;
    
            void main(void) {
                gl_Position = aVertexPosition;
                vTextureCoord = (aTextureCoord * vec2(1.0, -1.0)) * 2.0 + vec2(0, 1.0);
            }
        `

        let reduce = '#@'
        switch (this.type) {
            case 'max':
                reduce =
                    'max(texelColor0, max(texelColor1, max(texelColor2, texelColor3)))'
                break
            case 'min':
                reduce =
                    'min(texelColor0, min(texelColor1, min(texelColor2, texelColor3)))'
                break
            case 'mean':
                reduce =
                    '(texelColor0 + texelColor1 + texelColor2 + texelColor3) / 4.0'
                break
            case 'sum':
                reduce = `texelColor0 + texelColor1 + texelColor2 + texelColor3`
            default:
                throw Error(`No reduce type is specified: ${this.type}`)
        }

        this.shaderF = `
            precision highp float;
            varying highp vec2 vTextureCoord;
            uniform vec2 u_textureSize;
            uniform sampler2D uSampler;

            void main(void) {
                vec2 onePixel = vec2(1.0, 1.0) / u_textureSize;
                
                highp float texelColor0 = texture2D(uSampler, vTextureCoord).r;
                highp float texelColor1 = texture2D(uSampler, vTextureCoord + onePixel * vec2(0.0, 1.0)).r;
                highp float texelColor2 = texture2D(uSampler, vTextureCoord + onePixel * vec2(1.0, 0.0)).r;
                highp float texelColor3 = texture2D(uSampler, vTextureCoord + onePixel * vec2(1.0, 1.0)).r;

                highp float local_redu = ${reduce};
                // gl_FragColor = texture2D(uSampler, vTextureCoord);
                gl_FragColor =  vec4(vec3(local_redu), 1.0);
            }
        `
    }

    create_input_tex() {
        if (this.type === 'max' || this.type === 'min') {
            this.input_tex = initTexture(
                this.gl,
                this.render_size.width,
                this.render_size.height,
                this.gl.RGBA,
                this.gl.NEAREST
            )
        } else {
            this.input_tex = initTexture(
                this.gl,
                this.render_size.width,
                this.render_size.height
            )
        }
    }

    create_output_tex() {
        if (this.type === 'max' || this.type === 'min') {
            this.output_tex = initTexture(
                this.gl,
                this.render_size.width,
                this.render_size.height,
                this.gl.RGBA,
                this.gl.NEAREST
            )
        } else {
            this.output_tex = initTexture(
                this.gl,
                this.render_size.width,
                this.render_size.height
            )
        }
    }

    apply(input_tex, framebuffer) {
        const gl = this.gl
        let output_tex = this.output_tex

        const uniform_parm = {}
        uniform_parm.uniform2f = [
            this.shader_info.uniformLocations.u_textureSize,
            this.render_size.width,
            this.render_size.height,
        ]

        // * NOTE: clone data from extenral input_tex to this.input_tex, and reduction operaion will be done on this.input_tex and this.output_tex
        // * without modify original data on input_tex.
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer)
        gl.framebufferTexture2D(
            gl.FRAMEBUFFER,
            gl.COLOR_ATTACHMENT0,
            gl.TEXTURE_2D,
            input_tex,
            0
        )
        gl.bindTexture(gl.TEXTURE_2D, this.input_tex)
        gl.copyTexImage2D(
            gl.TEXTURE_2D,
            0,
            gl.RGBA,
            0,
            0,
            this.render_size.width,
            this.render_size.height,
            0
        )
        input_tex = this.input_tex

        let final_size = {
            w: this.render_size.width,
            h: this.render_size.height,
        }
        const D = 8
        let I = Math.min(this.render_size.height, this.render_size.width)
        let div_counter = 0

        do {
            gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer)
            gl.framebufferTexture2D(
                gl.FRAMEBUFFER,
                gl.COLOR_ATTACHMENT0,
                gl.TEXTURE_2D,
                output_tex,
                0
            )
            this.apply_shader(
                gl,
                this.shader_info,
                this.buffers,
                input_tex,
                this.render_size.width,
                this.render_size.height,
                uniform_parm
            )

            div_counter++
            final_size.h /= 2
            final_size.w /= 2
            I /= 2

            // console.log('reduce size: ', final_size, I)
            // if (div_counter > 1)
            //     break
            if (I >= D) {
                let tmp_tex = input_tex
                input_tex = output_tex
                output_tex = tmp_tex
            }
        } while (I >= D)

        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer)
        gl.framebufferTexture2D(
            gl.FRAMEBUFFER,
            gl.COLOR_ATTACHMENT0,
            gl.TEXTURE_2D,
            output_tex,
            0
        )

        final_size.h = Math.ceil(final_size.h)
        final_size.w = Math.ceil(final_size.w)
        let reduce_uint = new Uint8Array(final_size.h * final_size.w * 4)
        gl.readPixels(
            0,
            this.render_size.height - final_size.h,
            final_size.w,
            final_size.h,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            reduce_uint
        )

        let fianl_value = this.type !== 'min' ? 0 : 9999999
        for (let y = 0; y < final_size.h; y++) {
            for (let x = 0; x < final_size.w; x++) {
                const id = (y * final_size.w + x) * 4
                const v = reduce_uint[id]
                switch (this.type) {
                    case 'max':
                        fianl_value = Math.max(fianl_value, v)
                        break
                    case 'min':
                        fianl_value = Math.min(fianl_value, v)
                        break
                    case 'mean':
                    case 'sum':
                        fianl_value += v
                        break
                }
            }
        }
        if (this.type == 'mean') fianl_value /= final_size.w * final_size.h

        return [output_tex, fianl_value]
    }
}

export class NightVisionFilterGL {
    vShader = `
        attribute vec4 aVertexPosition;
        attribute vec2 aTextureCoord;

        uniform mat4 uModelViewMatrix;
        uniform mat4 uProjectionMatrix;

        varying highp vec2 vTextureCoord;
        varying highp vec3 vLighting;

        void main(void) {
            // gl_Position = uProjectionMatrix * uModelViewMatrix * aVertexPosition;
            gl_Position = aVertexPosition;
            vTextureCoord = aTextureCoord;
        }
    `

    fShader = `
        varying highp vec2 vTextureCoord;
        uniform sampler2D uSampler;

        void main(void) {
            highp vec4 texelColor = texture2D(uSampler, vTextureCoord);

            gl_FragColor = vec4(texelColor.rgb, texelColor.a);
        }
    `

    nvShader = `
        precision highp float;
        varying highp vec2 vTextureCoord;
        uniform sampler2D uSampler;
        void main(void) {
            const vec3 y_weight = vec3(0.29900, 0.58700, 0.11400);
            highp vec3 texelColor = texture2D(uSampler, vTextureCoord).rgb;
            float y = dot(texelColor, y_weight);
            float lum = clamp(log(y + 0.2) * 0.4 + 0.97, 0.0, 1.0);
            gl_FragColor = vec4(lum, clamp(lum * 1.2, 0.0, 1.0), lum, 1.0);
        }
    `

    constructor(canvas) {
        this.gl = canvas.getContext('webgl')
        const gl = this.gl

        if (!gl)
            throw Error(
                'Unable to initialize WebGL. Your browser or machine may not support it.'
            )

        this.nolshaderProgram = initShaderProgram(
            gl,
            this.vShader,
            this.fShader
        )
        this.nvShaderProgram = initShaderProgram(
            gl,
            this.vShader,
            this.nvShader
        )
        this.nolprogramInfo = {
            program: this.nolshaderProgram,
            attribLocations: {
                vertexPosition: gl.getAttribLocation(
                    this.nolshaderProgram,
                    'aVertexPosition'
                ),
                textureCoord: gl.getAttribLocation(
                    this.nolshaderProgram,
                    'aTextureCoord'
                ),
            },
            uniformLocations: {
                projectionMatrix: gl.getUniformLocation(
                    this.nolshaderProgram,
                    'uProjectionMatrix'
                ),
                modelViewMatrix: gl.getUniformLocation(
                    this.nolshaderProgram,
                    'uModelViewMatrix'
                ),
                uSampler: gl.getUniformLocation(
                    this.nolshaderProgram,
                    'uSampler'
                ),
            },
        }
        this.nvProgramInfo = {
            program: this.nvShaderProgram,
            attribLocations: {
                vertexPosition: gl.getAttribLocation(
                    this.nvShaderProgram,
                    'aVertexPosition'
                ),
                textureCoord: gl.getAttribLocation(
                    this.nvShaderProgram,
                    'aTextureCoord'
                ),
            },
            uniformLocations: {
                projectionMatrix: gl.getUniformLocation(
                    this.nvShaderProgram,
                    'uProjectionMatrix'
                ),
                modelViewMatrix: gl.getUniformLocation(
                    this.nvShaderProgram,
                    'uModelViewMatrix'
                ),
                uSampler: gl.getUniformLocation(
                    this.nvShaderProgram,
                    'uSampler'
                ),
            },
        }
        this.buffers = initBuffers(gl)
        this.texture = initTexture(gl)
    }

    drawScene(gl, programInfo, buffers, texture, scaledWidth, scaledHeight) {
        gl.clearColor(0.0, 0.0, 0.0, 1.0) // Clear to black, fully opaque
        gl.clearDepth(1.0) // Clear everything

        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)

        // const fieldOfView = 45 * Math.PI / 180;   // in radians
        const fieldOfView = 20
        const aspect = 1
        const zNear = 1
        const zFar = 3.0
        const projectionMatrix = gl_matrix.mat4.create()

        gl_matrix.mat4.perspective(
            projectionMatrix,
            fieldOfView,
            aspect,
            zNear,
            zFar
        )

        const modelViewMatrix = gl_matrix.mat4.create()
        gl.viewport(0, 0, scaledWidth, scaledHeight)

        gl_matrix.mat4.translate(
            modelViewMatrix, // destination matrix
            modelViewMatrix, // matrix to translate
            [-0.0, 0.0, -3.0]
        ) // amount to translate

        {
            const numComponents = 2
            const type = gl.FLOAT
            const normalize = false
            const stride = 0
            const offset = 0
            gl.bindBuffer(gl.ARRAY_BUFFER, buffers.position)
            gl.vertexAttribPointer(
                programInfo.attribLocations.vertexPosition,
                numComponents,
                type,
                normalize,
                stride,
                offset
            )
            gl.enableVertexAttribArray(
                programInfo.attribLocations.vertexPosition
            )
        }

        {
            const numComponents = 2
            const type = gl.FLOAT
            const normalize = false
            const stride = 0
            const offset = 0
            gl.bindBuffer(gl.ARRAY_BUFFER, buffers.textureCoord)
            gl.vertexAttribPointer(
                programInfo.attribLocations.textureCoord,
                numComponents,
                type,
                normalize,
                stride,
                offset
            )
            gl.enableVertexAttribArray(programInfo.attribLocations.textureCoord)
        }

        gl.useProgram(programInfo.program)

        gl.uniformMatrix4fv(
            programInfo.uniformLocations.projectionMatrix,
            false,
            projectionMatrix
        )
        gl.uniformMatrix4fv(
            programInfo.uniformLocations.modelViewMatrix,
            false,
            modelViewMatrix
        )
        gl.activeTexture(gl.TEXTURE0)

        gl.bindTexture(gl.TEXTURE_2D, texture)

        gl.uniform1i(programInfo.uniformLocations.uSampler, 0)

        {
            const vertexCount = 4
            const offset = 0

            gl.drawArrays(gl.TRIANGLE_STRIP, offset, vertexCount)
        }
    }

    render(bitmap, render_width, render_height) {
        updateTexture(this.gl, this.texture, bitmap)
        this.drawScene(
            this.gl,
            this.nvProgramInfo,
            this.buffers,
            this.texture,
            render_width,
            render_height
        )
    }
}

export class MotionGLRenderer {
    vexShader = `
        attribute vec4 aVertexPosition;
        attribute vec2 aTextureCoord;

        varying highp vec2 vTextureCoord;
        varying highp vec3 vLighting;

        void main(void) {
            gl_Position = aVertexPosition;
            vTextureCoord = aTextureCoord;
        }
    `

    fragShader = `
        precision highp float;
        varying highp vec2 vTextureCoord;
        uniform sampler2D uSampler;
        uniform float u_flipY;

        void main(void) {
            highp vec4 texelColor = texture2D(
                uSampler,
                vTextureCoord * vec2(1, -1) + vec2(0, 1.0)
            );

            gl_FragColor = vec4(texelColor.rgb, texelColor.a);
        }
    `

    constructor(canvas) {
        this._canvas = canvas
        this.gl = canvas.getContext('webgl')
        const gl = this.gl

        if (!gl)
            throw Error(
                'Unable to initialize WebGL. Your browser or machine may not support it.'
            )

        // * shader that draw fianl result to this._canvas default framebuffer
        {
            this.drawShaderProgram = initShaderProgram(
                gl,
                this.vexShader,
                this.fragShader
            )
            this.drawShaderInfo = {
                program: this.drawShaderProgram,
                attribLocations: {
                    vertexPosition: gl.getAttribLocation(
                        this.drawShaderProgram,
                        'aVertexPosition'
                    ),
                    textureCoord: gl.getAttribLocation(
                        this.drawShaderProgram,
                        'aTextureCoord'
                    ),
                },
                uniformLocations: {
                    uSampler: gl.getUniformLocation(
                        this.drawShaderProgram,
                        'uSampler'
                    ),
                    u_flipY: gl.getUniformLocation(
                        this.drawShaderProgram,
                        'u_flipY'
                    ),
                },
            }
        }

        this.motion_shader = new MotionShader(
            gl,
            canvas,
            {
                width: canvas.width / 1,
                height: canvas.height / 1,
            },
            0.8,
            false
        )
        this.avg_pool_shader = new AvgPoolingShader(gl, canvas, {
            width: canvas.width,
            height: canvas.height,
        })
        this.rect_shader = new RectShader(gl, canvas, {
            width: canvas.width,
            height: canvas.height,
        })
        this.reduce_2d_shader = new ReduceMax2DShader(gl, canvas, {
            width: canvas.width,
            height: canvas.height,
        })

        // * Create Textures
        this.buffers = initBuffers(gl)
        this.texture_a = initTexture(gl)
        this.texture_b = initTexture(gl)

        this.decay_buffer = [
            initTexture(
                gl,
                Number.parseInt(this._canvas.width / 1),
                Number.parseInt(this._canvas.height / 1)
            ),
            initTexture(
                gl,
                Number.parseInt(this._canvas.width / 1),
                Number.parseInt(this._canvas.height / 1)
            ),
        ]
        this.decay_framebuffer = initFBO(this.gl, this.decay_buffer[0])
        this.decay_buffer_switch = 0
        this.texture_update_long = initTexture(
            gl,
            this._canvas.width,
            this._canvas.height
        )

        this.frameCount = 0
        this.dropFrame = 10
    }

    setFramebuffer(fbo, width, height) {
        const gl = this.gl
        // make this the framebuffer we are rendering to.
        gl.bindFramebuffer(gl.FRAMEBUFFER, fbo)
        // Tell webgl the viewport setting needed for framebuffer.
        gl.viewport(0, 0, width, height)
    }

    drawScene(gl, programInfo, buffers, texture_a, scaledWidth, scaledHeight) {
        gl.bindFramebuffer(gl.FRAMEBUFFER, null)
        gl.viewport(0, 0 * scaledHeight, scaledWidth, scaledHeight)
        // const flipYLocation = gl.getUniformLocation(programInfo.program, "u_flipY")

        {
            const numComponents = 2
            const type = gl.FLOAT
            const normalize = false
            const stride = 0
            const offset = 0
            gl.bindBuffer(gl.ARRAY_BUFFER, buffers.position)
            gl.vertexAttribPointer(
                programInfo.attribLocations.vertexPosition,
                numComponents,
                type,
                normalize,
                stride,
                offset
            )
            gl.enableVertexAttribArray(
                programInfo.attribLocations.vertexPosition
            )
        }

        {
            const numComponents = 2
            const type = gl.FLOAT
            const normalize = false
            const stride = 0
            const offset = 0
            gl.bindBuffer(gl.ARRAY_BUFFER, buffers.textureCoord)
            gl.vertexAttribPointer(
                programInfo.attribLocations.textureCoord,
                numComponents,
                type,
                normalize,
                stride,
                offset
            )
            gl.enableVertexAttribArray(programInfo.attribLocations.textureCoord)
        }

        gl.useProgram(programInfo.program)

        gl.activeTexture(gl.TEXTURE0)
        gl.bindTexture(gl.TEXTURE_2D, texture_a)
        gl.uniform1i(programInfo.uniformLocations.uSampler, 0)
        gl.uniform1f(programInfo.uniformLocations.u_flipY, -1.0)

        {
            const vertexCount = 4
            const offset = 0
            gl.drawArrays(gl.TRIANGLE_STRIP, offset, vertexCount)
        }
    }

    add_motion(xmin, xmax, ymin, ymax) {
        for (let txture_id = 0; txture_id < 2; txture_id++) {
            let txt_motion_long = this.decay_buffer[txture_id]
            let texture_update_long = this.rect_shader.apply(
                txt_motion_long,
                this.decay_framebuffer,
                [xmin, xmax, ymin, ymax]
            )
            this.rect_shader.swap_output_tex(this.decay_buffer[txture_id])
            this.decay_buffer[txture_id] = texture_update_long
            console.log(
                'add_motion',
                xmin,
                xmax,
                ymin,
                ymax,
                texture_update_long
            )
        }

        this.rect_shader.apply(
            this.motion_shader.output_tex,
            this.decay_framebuffer,
            [xmin, xmax, ymin, ymax]
        )
        this.motion_shader.output_tex = this.rect_shader.swap_output_tex(
            this.motion_shader.output_tex
        )
    }

    clear_motion_texture() {
        for (let txture_id = 0; txture_id < 2; txture_id++) {
            const txt_motion_long = this.decay_buffer[txture_id]
            this.rect_shader.apply(
                txt_motion_long,
                this.decay_framebuffer,
                [0, 1, 0, 1],
                0.0
            )

            this.decay_buffer[txture_id] = this.rect_shader.swap_output_tex(
                txt_motion_long
            )
        }
        // this.rect_shader.apply(
        //     this.motion_shader.output_tex,
        //     this.decay_framebuffer,
        //     [0, 1, 0, 1],
        //     0.0
        // )
        // this.motion_shader.output_tex = this.rect_shader.swap_output_tex(this.motion_shader.output_tex)
    }

    render(bitmap_a, bitmap_b, render_width, render_height) {
        // ? simple way to draw motion block during debug process
        // let now = new Date()
        // if (now.getSeconds() % 10 == 0)
        //     this.add_motion(.1, .3, .1, 0.2)
        // this.add_motion(0.5 / 2, .9 / 2 , 0.5 / 2, .9 / 2)
        this.decay_buffer_switch++
        this.frameCount++

        const gl = this.gl
        gl.activeTexture(gl.TEXTURE0)
        updateTexture(gl, this.texture_a, bitmap_a)
        gl.activeTexture(gl.TEXTURE1)
        updateTexture(gl, this.texture_b, bitmap_b)

        const txt_motion_out = this.decay_buffer[
            (this.decay_buffer_switch + 1) % 2
        ]
        const txt_motion_long = this.decay_buffer[this.decay_buffer_switch % 2]

        // ! Swap textrue under same framebuffer for better performance.
        const motion_tex = this.motion_shader.apply(
            [this.texture_a, this.texture_b, txt_motion_long],
            this.decay_framebuffer
        )
        this.decay_buffer[
            (this.decay_buffer_switch + 1) % 2
        ] = this.motion_shader.swap_output_tex(txt_motion_out)

        const fianl_width = Number.parseInt(render_width / 4)
        const fianl_height = Number.parseInt(render_height / 4)

        const motion_stride2_tex = this.avg_pool_shader.apply(
            motion_tex,
            this.decay_framebuffer
        )

        const reduce_max2d_tex = this.reduce_2d_shader.apply(
            motion_stride2_tex,
            this.decay_framebuffer
        )

        // * Output

        this.drawScene(
            gl,
            this.drawShaderInfo,
            this.buffers,
            reduce_max2d_tex,
            render_width,
            render_height
        )

        let h_motion = new Uint8Array(fianl_width)
        let v_motion = new Uint8Array(fianl_height)

        let v_pixels = new Uint8Array(fianl_height * 4)
        let h_pixels = new Uint8Array(fianl_width * 4)

        if (this.frameCount > this.dropFrame) {
            gl.readPixels(
                0,
                render_height - fianl_height,
                1,
                fianl_height,
                gl.RGBA,
                gl.UNSIGNED_BYTE,
                v_pixels
            )
            gl.readPixels(
                0,
                render_height - 1,
                fianl_width,
                1,
                gl.RGBA,
                gl.UNSIGNED_BYTE,
                h_pixels
            )

            for (let x = 0; x < fianl_width; x++) {
                h_motion[x] = h_pixels[x * 4 + 1]
            }
            for (let y = 0; y < fianl_height; y++) {
                v_motion[y] = v_pixels[y * 4]
            }
        } else {
            // ! Not using first few frame from startup, there may contain blank frames.
        }

        return {
            horizontal_motion: h_motion,
            vertical_motion: v_motion,
        }
    }
}

export class BoundedFlowGL extends MotionGLRenderer {
    constructor(canvas) {
        super(canvas)
        const gl = this.gl
        this.reduceAllShaderInfo = {}
        this.debug_tex = initTexture(
            gl,
            this._canvas.width,
            this._canvas.height
        )

        this.img_grad_shader = new ImageGradShader(
            gl,
            canvas,
            {
                width: canvas.width,
                height: canvas.height,
            },
            false,
            true
        )

        this.dilate_shader = new DilateFilterShader(gl, canvas, {
            width: canvas.width,
            height: canvas.height,
        })

        this.gradmask_shader = new GradMaskShader(gl, canvas, {
            width: canvas.width,
            height: canvas.height,
        })

        this.reduce_max_shader = new ReduceAllShader(
            gl,
            canvas,
            { width: canvas.width, height: canvas.height },
            'max'
        )

        this.masking_shader = new MaskingShader(gl, canvas, {
            width: canvas.width,
            height: canvas.height,
        })

        this.avg_pool_shader_a = new AvgPoolingShader(
            gl,
            canvas,
            {
                width: canvas.width,
                height: canvas.height,
            },
            false,
            false
        )
        this.avg_pool_shader_b = new AvgPoolingShader(
            gl,
            canvas,
            {
                width: canvas.width,
                height: canvas.height,
            },
            false,
            false
        )

        this.motion_shader = new MotionShader(
            gl,
            canvas,
            {
                width: canvas.width / 2,
                height: canvas.height / 2,
            },
            0.8,
            true
        )
    }

    render(bitmap_a, bitmap_b, render_width, render_height) {
        // this.add_motion(0.1, .2, 0.2, .3)
        this.decay_buffer_switch++
        this.frameCount++

        const gl = this.gl
        gl.activeTexture(gl.TEXTURE0)
        updateTexture(gl, this.texture_a, bitmap_a)
        gl.activeTexture(gl.TEXTURE1)
        updateTexture(gl, this.texture_b, bitmap_b)

        const downsize_tex_a = this.avg_pool_shader_a.apply(
            this.texture_a,
            this.decay_framebuffer
        )
        const downsize_tex_b = this.avg_pool_shader_b.apply(
            this.texture_b,
            this.decay_framebuffer
        )

        const txt_motion_out = this.decay_buffer[
            (this.decay_buffer_switch + 1) % 2
        ]
        const txt_motion_long = this.decay_buffer[this.decay_buffer_switch % 2]

        const motion_tex = this.motion_shader.apply(
            [downsize_tex_a, downsize_tex_b, txt_motion_long],
            this.decay_framebuffer
        )

        const fianl_width = Number.parseInt(render_width / 4)
        const fianl_height = Number.parseInt(render_height / 4)

        const img_grad_tex = this.img_grad_shader.apply(
            downsize_tex_b,
            this.decay_framebuffer
        )

        // let reduce_ui = new Uint8Array(render_width * render_height * 4)
        // gl.readPixels(
        //     0, 0,
        //     render_width, render_height,
        //     gl.RGBA, gl.UNSIGNED_BYTE, reduce_ui
        // )
        // let max_p = -1
        // let red = new Uint8Array(render_width * render_height);
        // for (let i = 0; i < reduce_ui.length/4; i++) {
        //     const element = reduce_ui[i * 4];
        //     max_p = Math.max(max_p, element)
        //     red[i] = element
        // }
        // console.log('reduce_ui_max: ', max_p)

        let [final_tex, img_grad_max] = this.reduce_max_shader.apply(
            img_grad_tex,
            this.decay_framebuffer
        )
        console.log('img_grad_max: ', img_grad_max)

        const grad_mask_tex = this.gradmask_shader.apply(
            img_grad_tex,
            this.decay_framebuffer,
            Math.max(10.0, Number.parseInt(img_grad_max * 0.2))
            // 60
        )

        const dilate_tex = this.dilate_shader.apply(
            grad_mask_tex,
            this.decay_framebuffer
        )

        const masked_motion_tex = this.masking_shader.apply(
            [motion_tex, dilate_tex],
            this.decay_framebuffer
        )

        // const motion_stride_2_tex = this.avg_pool_shader.apply(
        //     masked_motion_tex,
        //     this.decay_framebuffer,
        // )

        // this.drawScene(
        //     gl,
        //     this.drawShaderInfo,
        //     this.buffers,
        //     masked_motion_tex,
        //     render_width,
        //     render_height
        // )

        const reduce_max2d_tex = this.reduce_2d_shader.apply(
            masked_motion_tex,
            this.decay_framebuffer
        )

        this.drawScene(
            gl,
            this.drawShaderInfo,
            this.buffers,
            reduce_max2d_tex,
            render_width,
            render_height
        )

        let h_motion = new Uint8Array(fianl_width)
        let v_motion = new Uint8Array(fianl_height)

        let v_pixels = new Uint8Array(fianl_height * 4)
        let h_pixels = new Uint8Array(fianl_width * 4)

        if (this.frameCount > this.dropFrame) {
            gl.readPixels(
                0,
                render_height - fianl_height,
                1,
                fianl_height,
                gl.RGBA,
                gl.UNSIGNED_BYTE,
                v_pixels
            )
            gl.readPixels(
                0,
                render_height - 1,
                fianl_width,
                1,
                gl.RGBA,
                gl.UNSIGNED_BYTE,
                h_pixels
            )

            for (let x = 0; x < fianl_width; x++) {
                h_motion[x] = h_pixels[x * 4 + 1]
            }
            for (let y = 0; y < fianl_height; y++) {
                v_motion[y] = v_pixels[y * 4]
            }
        } else {
            // ! Not using first few frame from startup, there may contain blank frames.
        }

        return {
            horizontal_motion: h_motion,
            vertical_motion: v_motion,
        }
    }
}
